import React from 'react';
import { Button, Modal } from 'flowbite-react';
import { FiCompass, FiLayout } from 'react-icons/fi';

/**
 * Shown after Continue-with-mobile OTP when there is no pending Interest / Pay & join.
 */
const GuestNextStepModal = ({ isOpen, onClose, onExplore, onGoDashboard }) => {
  return (
    <Modal show={isOpen} size="md" popup onClose={onClose}>
      <Modal.Body>
        <div className="pt-2 pb-1">
          <h2 className="text-xl font-bold text-[#13224d] mb-1">
            You&apos;re verified
          </h2>
          <p className="text-sm text-[#555555] mb-5">
            What would you like to do next?
          </p>

          <div className="flex flex-col gap-3">
            <button
              type="button"
              onClick={onExplore}
              className="flex items-start gap-3 text-left rounded-xl border border-[#D0D5DD] bg-[#FEFBFA] px-4 py-3 hover:border-primaryColor hover:bg-white transition"
            >
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primaryColor/10 text-primaryColor">
                <FiCompass size={18} />
              </span>
              <span>
                <span className="block font-semibold text-[#13224d]">
                  Explore chits here
                </span>
                <span className="block text-xs text-[#666666] mt-0.5">
                  Stay on this page to show interest or pay &amp; join a plan.
                </span>
              </span>
            </button>

            <button
              type="button"
              onClick={onGoDashboard}
              className="flex items-start gap-3 text-left rounded-xl border border-[#D0D5DD] bg-[#FEFBFA] px-4 py-3 hover:border-[#13224D] hover:bg-white transition"
            >
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#13224D]/10 text-[#13224D]">
                <FiLayout size={18} />
              </span>
              <span>
                <span className="block font-semibold text-[#13224d]">
                  Go to dashboard
                </span>
                <span className="block text-xs text-[#666666] mt-0.5">
                  Open the app as a guest to browse chits and manage your profile.
                </span>
              </span>
            </button>
          </div>

          <div className="flex justify-end mt-4">
            <Button color="light" size="sm" onClick={onClose}>
              Not now
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GuestNextStepModal;
